import {Project} from '../../model/project';
import {ProjectsAction, ProjectsActionType} from '../projects/projects.action';
import {initialProjectsState, ProjectsState} from '../projects/projects.state';

export function projectsReducer(state: ProjectsState = initialProjectsState, action: ProjectsAction): ProjectsState {
  switch (action.type) {
    case ProjectsActionType.GET_SUCCESS: {
      const projectsMap = action.payload.projects?.reduce(
        (projectsMap: Record<string, Project>, obj: Project) => ((projectsMap[obj._id] = obj), projectsMap),
        {}
      );
      return {...state, projects: action.payload.projects, projectsMap};
    }
    case ProjectsActionType.GET_SUMMARY_SUCCESS: {
      return {...state, projectsSummary: action.payload.projectsSummary};
    }
    case ProjectsActionType.GET_PROJECT_VIEW_SUCCESS: {
      const projectViews = {...state.projectViews, [action.payload.projectView._id]: action.payload.projectView};
      return {...state, projectViews};
    }
    case ProjectsActionType.UPDATE_SUCCESS: {
      const projectsMap = {...state.projectsMap, [action.payload.project._id]: action.payload.project};
      return {...state, projectsMap};
    }
    case ProjectsActionType.UPDATE_PROJECT_VIEW_TASK_ID:
      return {...state, projectViewTaskId: action.payload.id};

    case ProjectsActionType.GET_TASK_TEMPLATES_SUCCESS:
      return {...state, taskTemplates: action.payload.taskTemplates};
    case ProjectsActionType.UPDATE_ROUTINE_DETAIL_PARAMS:
      return {...state, projectViewRoutineDetailParams: action.payload.params};
    case ProjectsActionType.UPDATE_PROJECT_VIEW_TOKEN_PARAMS:
      return {...state, projectViewTokenFilterParams: action.payload.params};
    case ProjectsActionType.UPDATE_TWD_SUBTASK_VIEW:
      return {...state, twsSubtaskView: action.payload.view};
    case ProjectsActionType.UPDATE_REPEATING_TASK_HISTORY_MAP:
      return {
        ...state,
        repeatingTaskHistoryMap: {
          ...state.repeatingTaskHistoryMap,
          [action.payload.id]: action.payload,
        },
      };
    case ProjectsActionType.UPDATE_SCROLL_POSITION:
      return {...state, projectViewScrollPosition: action.payload.scrollPosition};
    case ProjectsActionType.UPDATE_CURRENT_PROJECTS_ROUTE:
      return {...state, currentProjectsRoute: action.payload.route};
    case ProjectsActionType.GET_PROJECT_CHALLENGE_SUCCESS: {
      const projectChallengeMap = {
        ...state.projectChallengeMap,
        [action.payload.projectId]: action.payload.challengeView,
      };
      return {...state, projectChallengeMap};
    }
    case ProjectsActionType.UPDATE_CHALLENGE_CYCLE_SUCCESS_THRESHOLD_SUCCESS: {
      const {projectId, cycleNumber, cycleSuccessThreshold} = action.payload;
      const existingView = state.projectChallengeMap[projectId];
      if (!existingView) return state;
      const updatedCycles = existingView.cycles.map(cycle =>
        cycle.cycleNumber === cycleNumber ? {...cycle, cycleSuccessThreshold: cycleSuccessThreshold} : cycle
      );
      return {
        ...state,
        projectChallengeMap: {
          ...state.projectChallengeMap,
          [projectId]: {...existingView, cycles: updatedCycles},
        },
      };
    }
    case ProjectsActionType.CLEAR:
      return {
        projects: [],
        projectsSummary: [],
        projectsMap: {},
        projectViews: {},
        projectChallenges: {},
        projectChallengeMap: {},
        projectViewTaskId: null,
        routineDetailMap: {},
        taskTemplates: [],
        projectViewRoutineDetailParams: null,
        projectViewTokenFilterParams: null,
        twsSubtaskView: 'subtask',
        repeatingTaskHistoryMap: {},
        projectViewScrollPosition: 0,
        currentProjectsRoute: null,
      };
    default:
      return state;
  }
}
